import "./ConfirmationModal.css";
import React, { Fragment } from "react";
// import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 274,
  height: 186,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const ConfirmationModal = ({
  title,
  description,
  openDialog,
  handleCloseDialog,
}) => {
  return (
    <Fragment>
      <Modal
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="confirmation-modal-container">
          <Typography id="modal-modal-title" className="title">
            {title}
          </Typography>
          <Typography id="modal-modal-description" className="description">
            {description}
          </Typography>

          <Box className="buttons-container">
            <button className="cancel-btn" onClick={handleCloseDialog}>
              Cancel
            </button>
            <button
              className="confirm-btn"
              onClick={() => handleCloseDialog(true)}
            >
              Confirm
            </button>
          </Box>
        </Box>
      </Modal>
    </Fragment>
  );
};

export default ConfirmationModal;
